var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFreudenberg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 391.1,
    height: 63.7,
    viewBox: "0 0 395 65",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004388",
    d: "M348 5.4c3.4 0 5.7.8 5.7 4.2 0 3.7-2.8 4.6-5.3 4.6h-3.2V5.4h2.8zm.8-4.9h-8.1c-1.3 0-1.8.9-1.8 2.1v27.9c0 .9 1.199 1.1 3.199 1.1 1.9 0 3.2-.1 3.2-1.1V18.8h1.9c3.3 0 4.3 2.7 5.3 4.9l2.9 6.8c.399 1 1.6 1.1 3.3 1.1 2.399 0 3.5-.1 3.5-.9 0-.3-.2-.9-.7-2.2l-2.5-5.8c-1.3-3-2-4.2-4.4-5.5 4.601-1.5 6-4.5 6-8C360.3 4 357.4.5 348.8.5zm-88.699 30L260 10.9l-.101-3.5 1.301 3 1.4 2.7 7.799 14.6c.9 1.8 1.9 3.8 4.601 3.8h2.7c1.1 0 2.4-.6 2.4-2.3V1.5c0-.9-1.201-1-2.9-1-1.6 0-2.9.1-2.9 1 0 15.5 0 16.8.1 18 .101 3.3-.1.4.101 3.4h-.101l-.9-1.9-9.101-17.3C263.2 1.4 262.5.5 260 .5h-3.399c-1.5 0-2.301 1-2.301 2.3v27.7c0 .9 1.2 1.1 2.9 1.1 1.6 0 2.901-.2 2.901-1.1zM192.5 1.5c0-.9-1.2-1-3.2-1-1.9 0-3.2.1-3.2 1v18c0 3.7-1.4 7.3-6.3 7.3s-6.4-3.7-6.4-7.3v-18c0-.9-1.2-1-3.2-1-1.9 0-3.2.1-3.2 1v18.6c0 8.9 5.8 11.9 12.7 11.9 6.9 0 12.7-3 12.7-11.9V1.5h.1zM332 26.6h-10.9v-8.8h9.101c1.2 0 1.3-.7 1.3-2.4s-.1-2.4-1.3-2.4H321.1V5.5h10.8c1.199 0 1.3-.7 1.3-2.5s-.101-2.5-1.3-2.5h-15.3c-1.3 0-1.899.9-1.899 2.1v27c0 1.3.6 1.9 1.899 1.9H332c1.2 0 1.3-.7 1.3-2.5 0-1.7-.1-2.4-1.3-2.4zm-84.2 0h-10.9v-8.8h9.1c1.2 0 1.3-.7 1.3-2.4s-.1-2.4-1.3-2.4h-9.101V5.5H247.7c1.199 0 1.3-.7 1.3-2.5s-.101-2.5-1.3-2.5h-15.301c-1.299 0-1.899.9-1.899 2.1v27c0 1.3.601 1.9 1.899 1.9h15.4c1.2 0 1.301-.7 1.301-2.5.001-1.7-.201-2.4-1.3-2.4zm-86.8 0h-10.9v-8.8h9.1c1.2 0 1.3-.7 1.3-2.4s-.1-2.4-1.3-2.4h-9.1V5.5h10.8c1.2 0 1.3-.7 1.3-2.5s-.1-2.5-1.3-2.5h-15.3c-1.3 0-1.9.9-1.9 2.1v27c0 1.3.6 1.9 1.9 1.9H161c1.2 0 1.3-.7 1.3-2.5 0-1.7-.1-2.4-1.3-2.4zm-52.1-7.5c1.2 0 1.3-.7 1.3-2.5 0-1.9-.1-2.6-1.3-2.6h-9.2V5.7h9.8c1.2 0 1.3-.7 1.3-2.6s-.1-2.6-1.3-2.6h-14c-1.4 0-2.1.7-2.1 2.1v27.9c0 .9 1.2 1.1 3.2 1.1 1.9 0 3.2-.1 3.2-1.1V19.1h9.1zM381.2 0C372.9 0 365 4.7 365 16.1c0 8.5 4.4 15.9 16 15.9 3.5 0 6.1-.7 8.1-1.4 1.9-.7 1.9-.9 1.9-2.5V18c0-1.2-1-1.3-3.1-1.3-1.7 0-3.2 0-3.2 1.2V26c-.9.6-2.2.8-3.601.8-7.199 0-9.699-5.8-9.699-11 0-7.1 4.699-10.7 10.199-10.7 3.7 0 6.2 1.6 7.301 2.3.5.3.8.4 1 .4.6 0 .899-.9.899-2.7 0-1.1.101-1.8-.7-2.5C389 1.4 385.7 0 381.2 0zm-84.7 5.3c3.2 0 4.9.9 4.9 3.8 0 3.2-2 4.1-4.601 4.1h-3.3V5.3h3.001zm.3-4.8h-7.9c-1.199 0-1.799.7-1.799 2.1v27c0 1.3.6 1.9 1.799 1.9h8.301c8.899 0 12.399-4.2 12.399-9.3 0-4.8-3.199-7-6.199-7.5 2.199-.9 4.399-2.7 4.399-6.5 0-4.8-3.8-7.7-11-7.7zM297 18c4.5 0 6 1.5 6 4.3 0 3.7-2.6 4.5-5.2 4.5h-4.4V18h3.6zM208.899.5h-8C199.7.5 199 1.4 199 2.6v27c0 1.3.601 1.9 1.899 1.9h7.5c12.4 0 16.5-6.4 16.5-15.7 0-9-4-15.3-16-15.3zm-.298 5c6 0 9.799 2.9 9.799 10.6 0 7.5-3.5 10.6-9.699 10.6H205.4V5.5h3.201zM125.1 5.4c3.4 0 5.7.8 5.7 4.2 0 3.7-2.8 4.6-5.3 4.6h-3.2V5.4h2.8zm.8-4.9h-8.1c-1.3 0-1.8.9-1.8 2.1v27.9c0 .9 1.2 1.1 3.2 1.1 1.9 0 3.2-.1 3.2-1.1V18.8h2c3.2 0 4.2 2.7 5.2 4.9l2.9 6.8c.4 1 1.5 1.1 3.3 1.1 2.4 0 3.5-.1 3.5-.9 0-.3-.2-.9-.7-2.2l-2.5-5.8c-1.3-3-2-4.2-4.4-5.5 4.6-1.5 6-4.5 6-8-.3-5.2-3.3-8.7-11.8-8.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 34.096,
    y1: 54.292,
    x2: 60.908,
    y2: 27.481,
    gradientTransform: "matrix(1 0 0 -1 .16 62.735)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    style: {
      stopColor: "#004388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    style: {
      stopColor: "#00a6e2"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M37.6 10.1c-4.5 0-7 2-7.4 2.4v.1c1.6-.4 3.1-.6 4.3-.6 5.8 0 10.2 4.1 13 7.4l6.7 7.8c3 3.5 5.5 4.4 8.3 4.4 1.1 0 2.2-.1 2.5-.2v-.1c-.3-.1-2.7-.9-6.1-4.9l-5-6c-4.1-5.1-9-10.3-16.3-10.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 33.27,
    y1: 50.455,
    x2: 54.395,
    y2: 29.33,
    gradientTransform: "matrix(1 0 0 -1 .16 62.735)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    style: {
      stopColor: "#004388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    style: {
      stopColor: "#00a6e2"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M34 14c-1.1 0-2.3.2-2.7.5v.1c3.5.5 6.2 1.9 9.7 5.9l6.3 7.3c1.9 2.3 4.6 3.7 7.6 3.7.6 0 1.4-.1 1.9-.2v-.1c-1.7-.5-3.6-1.3-5.6-3.7L44.5 20c-2.4-2.9-6.5-6-10.5-6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 12.509,
    y1: 73.18,
    x2: 65.117,
    y2: 20.573,
    gradientTransform: "matrix(1 0 0 -1 .16 62.735)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cedff5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    style: {
      stopColor: "#5dc0eb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    style: {
      stopColor: "#00a6e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299,
    style: {
      stopColor: "#009dda"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#005c9f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    style: {
      stopColor: "#004388"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M74.5.4h-71C1.4.4 0 1.5 0 4v24c0 2 1.4 3.5 3.4 3.5h2.3c5.2 0 8.9-5.4 13.9-11.3C25 13.8 30.8 7.9 38.9 7.9c8 0 14 5.8 19.5 12.4C63.7 26.5 67 31.5 72 31.5h2c2.6 0 4-1.6 4-3.5V4C78 1.4 76.5.4 74.5.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#004388"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1 63.4V48.5h2v14.9h-2zM110.9 63.4l-7.3-9.601c-.8-1-1.2-1.6-1.5-2.199 0 .5.1 1.1.1 1.9v10h-2v-15h2.1l7 9.299c.9 1.201 1.3 1.801 1.6 2.4V48.5h2v14.9h-2zM127.5 63.4l-7.3-9.601c-.8-1-1.2-1.6-1.5-2.199 0 .5.1 1.1.1 1.9v10h-2v-15h2.1l7 9.299c.9 1.201 1.3 1.801 1.6 2.4V48.5h2v14.9h-2zM134.6 50.5c1.3-1.301 3.2-2.101 5.3-2.101 2.3 0 4.3.899 5.6 2.3 1.2 1.4 1.9 3.2 1.9 5.301 0 2.299-.8 4.299-2.2 5.6-1.3 1.3-3.2 2-5.3 2s-3.8-.7-5.1-1.9c-1.5-1.4-2.3-3.4-2.3-5.699 0-2.202.7-4.101 2.1-5.501zm5.3-.3c-3.2 0-5.3 2.301-5.3 5.801 0 3.6 2.1 5.799 5.3 5.799 3.2 0 5.3-2.299 5.3-5.799 0-3.401-1.9-5.801-5.3-5.801zM155.6 63.5h-1.3l-6-15h2.2l3.6 9.5.9 2.399c.3-.8.5-1.5.9-2.399l3.9-9.5h2.1l-6.3 15zM171.6 63.4l-1.5-3.899h-5.8l-1.4 3.899h-2l5.7-15h1.3l5.8 15h-2.1zm-3.8-10.101c-.3-.699-.5-1.399-.6-1.899-.1.5-.3 1.101-.6 1.8l-1.7 4.5h4.4l-1.5-4.401zM183.8 50.299h-4.2V63.4h-2V50.299h-4.3V48.5h11.1l-.6 1.799zM186.7 63.4V48.5h2v14.9h-2zM203.399 63.4l-7.299-9.601c-.801-1-1.201-1.6-1.5-2.199 0 .5.1 1.1.1 1.9v10h-2v-15h2.1l7 9.299c.9 1.201 1.301 1.801 1.6 2.4V48.5h2v14.9h-2.001zM215.899 63.7c-4.5 0-7.5-3.1-7.5-7.5 0-4.6 3.201-7.8 8-7.8 1.9 0 3.4.5 4.201.899v2c-1-.5-2.5-1.1-4.201-1.1-3.799 0-5.799 2.4-5.799 5.801 0 3.6 2.199 5.899 5.799 5.899 1.201 0 2.101-.2 2.701-.5v-5.2h2V62.5c-.999.5-2.999 1.2-5.201 1.2zM239.7 50.299h-4.2V63.4h-2V50.299h-4.3V48.5h11.1l-.6 1.799zM242.8 50.5c1.301-1.301 3.2-2.101 5.301-2.101 2.299 0 4.299.899 5.6 2.3 1.199 1.4 1.9 3.2 1.9 5.301 0 2.299-.801 4.299-2.201 5.6-1.299 1.3-3.199 2-5.299 2-2.101 0-3.801-.7-5.101-1.9-1.5-1.4-2.3-3.4-2.3-5.699 0-2.202.699-4.101 2.1-5.501zm5.301-.3c-3.201 0-5.301 2.301-5.301 5.801 0 3.6 2.1 5.799 5.301 5.799 3.199 0 5.299-2.299 5.299-5.799-.001-3.401-1.9-5.801-5.299-5.801zM265.3 63.7c-4.5 0-7.5-3.1-7.5-7.5 0-4.6 3.2-7.8 8-7.8 1.9 0 3.4.5 4.2.899v2c-1-.5-2.5-1.1-4.2-1.1-3.8 0-5.8 2.4-5.8 5.801 0 3.6 2.2 5.899 5.8 5.899 1.2 0 2.1-.2 2.7-.5v-5.2h2V62.5c-1 .5-2.899 1.2-5.2 1.2zM274.2 63.4V48.5h7.6l-.699 1.799h-5V54.9H281v1.8h-4.899v5h5.699v1.8h-7.6v-.1zM294.3 50.299h-4.199V63.4h-2V50.299H283.8V48.5h11.1l-.6 1.799zM307 63.4v-6.7h-7.9v6.7h-1.999V48.5h1.999V55h7.9v-6.5h2v14.9h-2zM313 63.4V48.5h7.6l-.699 1.799h-5V54.9h4.899v1.8H315v5h5.7v1.8H313v-.1zM331.7 63.4c-2.4-3.8-3.7-6-4.3-6.2h-1.5v6.2h-2V48.5h3.399c3.601 0 5.101 1.799 5.101 4.1 0 2.1-1.4 3.4-2.9 4 .5.3 2.2 3 4.6 6.8h-2.4zm-4.4-13.101h-1.4V55.6h1.5c1.6 0 2.899-1.2 2.899-2.7.001-1.4-.799-2.601-2.999-2.601z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFreudenberg);
export default __webpack_public_path__ + "static/media/logo_freudenberg.84aa9be471fb485639d34532a431369c.svg";
export { ForwardRef as ReactComponent };